import { getBaseURL, getClient } from '../BLL/clients/HttpClient';
import { ApiEndPoint } from '../BLL/Enums/ApiEndPoint';

export type WhatsAppMember = {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
};

export type WhatsAppMembersResponse = {
  members: WhatsAppMember[];
};

export type SendWhatsAppMessageResponse = {
  success: boolean;
  messageId?: string;
};

export const getWhatsAppMembers = async (
  carrierId: number,
  search: string
): Promise<WhatsAppMember[]> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const { data } = await client.get<WhatsAppMembersResponse>('v1/whatsapp/members', {
    params: { carrierId, search },
  });

  return data.members;
};

export const sendWhatsAppMessage = async (
  memberId: string,
  messageType: string
): Promise<SendWhatsAppMessageResponse> => {
  const authBaseUrl = getBaseURL(ApiEndPoint.Auth);
  const client = getClient({ baseURL: authBaseUrl });

  const { data } = await client.post<SendWhatsAppMessageResponse>(
    'v1/whatsapp/send',
    {
      memberId,
      messageType,
    }
  );

  return data;
};
